export default __webpack_public_path__ + "static/media/16-1.f724a04a.mp3";